import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import Image from '../Image/Image';
import ContactRow from '../ContactRow/ContactRow';

import useSWR from 'swr';
import { apiClient } from '../../../helpers/apiHelperV2';

function DealerInfo() {
    const markenStandort = useSelector(markenStandortSelector);

    const { data: seitenTexteResponse } = useSWR(`/api/v1/SeitenTexte?standortUrl=${markenStandort.url}`, async url => {
        const { data } = await apiClient.get(url);
        return data;
    });

    const seitenTexte = useMemo(() => seitenTexteResponse?.body ?? [], [seitenTexteResponse]);
    const about = (seitenTexte && seitenTexte.find(text => text.name === 'About-Text')) || undefined;

    return (
        <>
            <section className="uk-section uk-section-default uk-section-small">
                <div className="uk-container">
                    <div className="uk-grid uk-child-width-1-2@m" data-uk-grid="">
                        <div>
                            <Image
                                className="uk-width-1-1"
                                src={`https://techno-images.s3.eu-central-1.amazonaws.com/standort-images/${markenStandort.gesellschafterNr}/${markenStandort.standortNr}/Autohaus.jpg`}
                                alt="heandler-info"
                                resizeWidth={585}
                            />
                        </div>
                        <div>
                            <h3>{markenStandort.anschrift.firma}</h3>
                            {about && <div className="seitentext-content" dangerouslySetInnerHTML={{ __html: about.text }} />}
                        </div>
                    </div>
                </div>
            </section>
            <ContactRow location={markenStandort} />
        </>
    );
}

export default DealerInfo;
